import { create } from 'zustand'
import ApiClient from '../views/api/client'
import { toast } from 'react-toastify'

const apiClient = new ApiClient()

export const useProgramStore = create((set, get) => ({
  programs: [],
  filteredPrograms: [],
  addPrograms: [],
  // updatePrograms: [],
  searchQuery: '',
  showDeleteModal: false,
  programToDelete: null,
  programToUpdate: null,
  showUpdateModal: false,
  showAddProgramModal: false,
  error: '',
  loading: false,

  //client search state
  // setPrograms: (programs) => {
  //   set({ programs, filteredPrograms: programs })
  // },

  // setSearchQuery: (query) => {
  //   set({ searchQuery: query })
  //   get().filterPrograms(query)
  // },

  // filterPrograms: (query) => {
  //   const lowerQuery = query.toLowerCase()
  //   const { programs } = get()

  //   const filtered = programs.filter(
  //     (program) =>
  //       program?.name?.toLowerCase().includes(lowerQuery) ||
  //       program?.id?.toString().includes(lowerQuery) ||
  //       program?.program_code?.toLowerCase().includes(lowerQuery)
  //   )

  //   set({ filteredPrograms: filtered })
  // },

  // Modal for deleting program
  openDeleteModal: (program) => {
    set({ showDeleteModal: true, programToDelete: program })
  },

  closeDeleteModal: () => {
    set({ showDeleteModal: false, programToDelete: null })
  },

  // Modal for updating program
  openUpdateModal: (program) => {
    set({ showUpdateModal: true, programToUpdate: program })
  },

  closeUpdateModal: () => {
    set({ showUpdateModal: false, programToUpdate: null })
  },

  // Modal for adding new program
  openAddProgramModal: () => {
    set({ showAddProgramModal: true })
  },

  closeAddProgramModal: () => {
    set({ showAddProgramModal: false })
  },
  // fetchPrograms: async () => {
  //   set({ loading: true })
  //   try {
  //     const response = await apiClient.fetchAllPrograms()
  //     set((state) => ({
  //       programs: [...state.programs, response.data],
  //       loading: false,
  //     }))
  //     return {
  //       success: true,
  //       message: `${response.data} created successfuly!`,
  //     }
  //   } catch (error) {
  //     set({
  //       error: error.response?.data?.detail || 'Error fetching programs',
  //       loading: false,
  //     })
  //     return { success: false, message: 'Failed to fetch client' }
  //   }
  // },

  //add program
  addProgram: async (name, image, new_code) => {
    set({ loading: true })
    try {
      const response = await apiClient.addProgram(name, image, new_code)
      if (response.data) {
        set((state) => ({
          addPrograms: [...state.addPrograms, response.data],
          loading: false,
        }))
        // toast.success('Program added successfully!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'color',
        // })
      } else {
        // toast.success('Program was not added!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'color',
        // })
      }
    } catch (error) {
      set({ error: error.response?.data?.detail, loading: false })
    }
  },

  //update program
  updateProgram: async (programId, name, new_code, image) => {
    set({ loading: true })
    try {
      const response = await apiClient.updateProgram(
        programId,
        name,
        new_code,
        image
      )
      if (response.error) throw new Error(response.error)
      if (response.data) {
        const updatedProgram = get().programs.map((p) =>
          p.id === programId ? response.data : p
        )
        set({
          programs: updatedProgram,
          programToUpdate: null,
          showUpdateModal: false,
        })
        // toast.success('Program updated successfully!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'colored',
        // })
      } else {
        // toast.error('Program was not updated!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'colored',
        // })
      }
    } catch (error) {
      set({ error: error.response?.data?.detail })
    }
  },

  //delete program
  deleteProgram: async (programId) => {
    set({ loading: true })
    try {
      const response = await apiClient.deleteProgram(programId)
      const updatedProg = get().filter((c) => c.id !== programId)
      set({ programs: updatedProg, loading: false })
      // toast.success(`Program deleted successfully ${programId}`, {
      //   position: 'top-right',
      //   autClose: 3000,
      //   theme: 'colored',
      // })
      return { data: response.data }
    } catch (error) {
      set({ error: error.response?.data?.detail, loading: false })
    }
  },
  setError: (err) => set({ error: err }),
}))
